function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// antd base theme
import AntdBaseTheme from "./antd";
// njoyd base theme
import NjoydBaseTheme from "./njoyd";
// njoyd 用户配置对象
import { ConfigObject } from "../config/index";

/**
 * @description: 组装 Antd 主题属性，以 AntdTheme 支持的属性为基础，多余属性的剔除，表示该属性不支持
 * @param {*} theme 传入单独的主题配置，优先级最高，一般用于组件本身属性传入
 * @param {*} themeMode 主题组装模式，默认 all
 * @return {*} 组装好的 AntdTheme 主题属性
 */
export function antdTheme(theme, themeMode) {
  // Base主题配置
  var baseTheme = _objectSpread({}, AntdBaseTheme);
  // 用户全局配置传入的主题
  var configTheme = ConfigObject && ConfigObject.theme || {};
  // 用户组件传入的主题
  var componentTheme = theme || {};
  // 返回
  return themeFilter(baseTheme, configTheme, componentTheme, themeMode);
}

/**
 * @description: 组装 Njoyd 主题属性，以 NjoydTheme 支持的属性为基础，多余属性的剔除，表示该属性不支持
 * @param {*} theme 传入单独的主题配置，优先级最高，一般用于组件本身属性传入
 * @param {*} themeMode 主题组装模式，默认 all
 * @return {*} 组装好的 Njoyd 主题属性
 */
export function njoydTheme(theme, themeMode) {
  // Base主题配置
  var baseTheme = _objectSpread({}, NjoydBaseTheme);
  // 用户全局配置传入的主题
  var configTheme = ConfigObject && ConfigObject.theme || {};
  // 用户组件传入的主题
  var componentTheme = theme || {};
  // 返回
  return themeFilter(baseTheme, configTheme, componentTheme, themeMode);
}

/**
 * @description: 主题按优先级过滤组装，优先级：用户组件传入的主题 > 用户全局配置传入的主题 > Base主题配置
 * @param {*} baseTheme 默认主题配置
 * @param {*} configTheme 用户全局配置传入的主题
 * @param {*} componentTheme 用户组件传入的主题
 * @param {*} themeMode 主题组装模式，默认 all
 * @return {*} 按优先级过滤组装后的主题对象
 */
function themeFilter(baseTheme, configTheme, componentTheme, themeMode) {
  // Base keys
  var keys = Object.keys(baseTheme);
  // 新对象
  var themeObject = {};
  // 判断主题组装模式
  if (themeMode === 1) {
    // 按优先级组装：全局配置传入的主题 + 组件传入的主题
  } else {
    // 以 Base 主题为基础，包含全部主题
    themeObject = _objectSpread({}, baseTheme);
  }
  // 便利Base
  for (var index in keys) {
    // 获取 key
    var key = keys[index];
    // 根据优先级判断取值
    if (componentTheme[key]) {
      // 用户组件配置传入的主题
      themeObject[key] = componentTheme[key];
    } else if (configTheme[key]) {
      // 用户全局配置传入的主题
      themeObject[key] = configTheme[key];
    }
  }
  // 返回
  return themeObject;
}